import { LANGUAGE_COOKIE } from "../../../cookies/LANGUAGE_COOKIE";
import getSiteInfo from "./getSiteInfo";

const getLanguage = (): string => {
  const { defaultLang } = getSiteInfo();
  if (typeof document === "undefined") return defaultLang;
  const raw = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${LANGUAGE_COOKIE}=`))
    ?.split("=")[1];
  return raw ? decodeURIComponent(raw) : defaultLang;
};

export default getLanguage;
